import { render } from "./readjustmentLotComponent.vue?vue&type=template&id=49966e5e"
import script from "./readjustmentLotComponent.vue?vue&type=script&lang=js"
export * from "./readjustmentLotComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__